import React, { Component } from 'react'
import { TextInput } from '../shared/TextInput'
import { Crementer } from '../shared/NumberCrementer'
import { selectors as inventorySelectors } from '../sagas/inventory'
import { selectors as productShowSelectors } from '../sagas/products/show'
import { actions as inventoryUpdateActions } from '../sagas/inventory/new'
import { actions as productUpdateActions } from '../sagas/products/update'
import { actions as inventoryActions } from '../sagas/inventory'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import '../stylesheets/update_product.sass'
import _ from 'lodash'

class Price extends Component {
  constructor(props) {
    super(props)
    this.toggleAlwaysOn = this.props.actions.productUpdateActions.toggleAlwaysOn.bind(this)
  }

  getInventoryCount = () => {
    return this.props.product
      && this.props.product['attributes']
      && this.props.product['attributes']['inventoryCount']
  }

  addInventory = () => {
    this.props.actions.inventoryUpdateActions.createInventory(
      this.props.product['id'],
      this.props.size['id'],
      {
        post_request: this.props.showProduct && this.props.showProduct(this.props.product && this.props.product['id']),
        inventory_type: 'future'
      }
    )
  }

  removeInventory = () => {
    this.props.actions.inventoryUpdateActions.destroyInventory(
      this.props.product['id'],
      this.props.size['id'],
      {
        post_request: this.props.showProduct && this.props.showProduct(this.props.product && this.props.product['id']),
        inventory_type: 'future'
      }
    )
  }

  render() {
    let inventories = this.props.inventories(this.props.product)
    let value = _.snakeCase(this.props.input)
    return (
      <div>
        <div className={'price-set'}>
          <div className={'product-inventory-crementer'}>
            <label>
              { `${_.startCase(this.props.input)}` }
            </label>
            <Crementer
              wrapperClass='inventory-crement-wrapper'
              value={ this.getInventoryCount()[_.camelCase(this.props.size['size'])] }
              valueClass='inventory'
              increment={ this.addInventory }
              decrement={ this.removeInventory }
              incrementClass={'add-inventory'}
              decrementClass={'remove-inventory'}
            />
          </div>
          <div className={'inventory-price'}>
            <TextInput
              label={ `${_.startCase(this.props.input)} Price` }
              placeholderText={'Price'}
              bootstrapValidator={'number'}
              inputName={ this.props.input }
              inputClass={ 'price' }
              extraClass={'price-input'}
            />
          </div>
        </div>
        <div className={'always-show-wrapper'}>
          <div className={'always-show'}>
            <label>
              { `Always Show ${_.startCase(this.props.input)}s` }
            </label>
            <div onClick={() => this.toggleAlwaysOn(_.snakeCase(this.props.input), this.props.product) } className={ this.props.alwaysOnKegSizes.includes(_.snakeCase(this.props.input)) ? 'toggle-button on' : 'toggle-button off'  }>
              <div className='toggle-switch'/>
            </div>
          </div>
          <div className={'always-show-quantity'}>
            <TextInput
              label={ 'Quantity' }
              placeholderText={'0'}
              bootstrapValidator={'number'}
              inputName={ `${this.props.input}Quantity` }
              inputClass={ 'price' }
              extraClass={'price-input'}
            />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (store) => ({
  inventories: inventorySelectors.jsonApiInventory,
  products: inventorySelectors.products(store),
  alwaysOnKegSizes: productShowSelectors.alwaysOnKegSizes(store)
});

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      inventoryActions: bindActionCreators(inventoryActions, dispatch),
      inventoryUpdateActions: bindActionCreators(inventoryUpdateActions, dispatch),
      productUpdateActions: bindActionCreators(productUpdateActions, dispatch)
    }
  }
}

export default (connect(mapStateToProps, mapDispatchToProps)(Price))



// WEBPACK FOOTER //
// ./src/Products/price.jsx